export enum API_GITHUB {
  Resources = 'https://api.github.com/users/',
}
export enum USER_DEFAULT {
  Name = 'flubyGit',
}
export enum LOADING_PROPS {
  Color = '#fff',
  Type = 'spinningBubbles',
}
